export default __webpack_public_path__ + "img/Inter-ExtraLight_f270980.woff2";